import React from 'react';

export default {
  contextContent: function() {
    if (this.props.page_type == '503') {
      if (this.props.has_status_page == 'no') {
        return (
          <p>
            Go back to the previous page and try again.
            <br />
            If you think something is broken, report a problem.
          </p>
        );
      } else if (this.props.has_status_page == 'non-customer') {
        return (
          <p>
            Check our status page for more information. Report a problem if you
            think we are unaware of the issue.
          </p>
        );
      } else {
        return (
          <p>
            Our status page is currently reporting a status of{' '}
            <strong id="replace-with-fetched-data">
              <em>will fetch from status page...</em>
            </strong>
            .
          </p>
        );
      }
    } else if (this.props.page_type == 'maintenance') {
      if (this.props.has_status_page == 'no') {
        return (
          <p>
            Sorry for the inconvenience. We’ll be back up and running as fast as
            possible.
          </p>
        );
      } else if (this.props.has_status_page == 'non-customer') {
        return (
          <div>
            <p>
              Sorry for the inconvenience. We’ll be back up and running as fast
              as possible.
            </p>
            <p>Check our status page for more information.</p>
          </div>
        );
      } else {
        return (
          <div>
            <p>
              This scheduled maintenance period is for <br />
              <span id="replace-with-fetched-data">
                <em>will fetch maintenance period...</em>
              </span>
            </p>
            <p>Check our status page for more information.</p>
          </div>
        );
      }
    }
  },
};
